module.exports = __webpack_public_path__ + "img/wx.0531f853.png";